<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />

    <div class="flex items-center justify-between mb-6">

      <span class="group flex items-center py-3 mb-6">
        <icon name="profile" class="mr-4 w-8 h-8 text-gray-700"/>
        <h1 class="text-3xl font-bold">
        <span><small>Profile</small></span>
        <span class="font-medium">&nbsp;></span>
        {{ form.first_name }} {{ form.last_name }}
      </h1>
      </span>  
      <!-- <img v-if="user.photo" class="block ml-4 w-8 h-8 rounded-full" :src="user.photo" />  -->
    </div>     

    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore"> This user has been deleted. </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="relative block p-4">
          <AvatarInput v-model="form.photo" class="w-48 h-48 rounded-full ml-auto mr-auto" :default-src="user.photo"/>
        </div>    
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Full Name " />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="hidden pb-8 pr-6 w-full lg:w-1/2" label="Last name" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email " />
          <text-input v-model="form.mobile" :error="form.errors.mobile" class="pb-8 pr-6 w-full lg:w-1/2" label="Mobile Number " />
          <text-input v-model="form.telephone" :error="form.errors.telephone" class="pb-8 pr-6 w-full lg:w-1/2" label="Office/Home Number " />
          <text-input v-model="form.certification" disabled readonly :error="form.errors.certification" class="hidden pb-8 pr-6 w-full lg:w-1/2" label="Certificate No/ID " />
          <text-input v-model="form.expiry" disabled readonly :error="form.errors.expiry" class="hidden pb-8 pr-6 w-full lg:w-1/2" label="Expiry " />
          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Profile Picture " />
          <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Password " />
          
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <!-- <button v-if="!user.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete User</button> -->
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Information</loading-button>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import { ref } from "vue";
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import Icon from '@/Shared/Icon'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import axios from 'axios'
import AvatarInput from '@/Shared/AvatarInput'
import Modal from "@/Shared/Modal.vue"
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';
import { Vue3ToggleButton } from 'vue3-toggle-button'
import '../../../../node_modules/vue3-toggle-button/dist/style.css'

export default {
  components: {
    FileInput,
    Head,
    Link,
    ref,
    Modal,
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    AvatarInput,
    Datepicker,
    StepProgress,
    Vue3ToggleButton,
  },
  layout: Layout,
  props: {
    user: Object,
    attachments: Object,
  },
  remember: 'form',
  setup() {
    
    let params = new URLSearchParams(window.location.search)
    const modalActive = ref(true);
    
    if(params.size==0){
      modalActive.value = false  
    }else{
      modalActive.value = true  
    } 

    const toggleModal = () => {     
      modalActive.value = !modalActive.value;
    };

    return { modalActive, toggleModal };
  },  
  data() {
    return {
      form: this.$inertia.form({
        _method: 'post',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: '',
        owner: this.user.owner,
        mobile: this.user.mobile,
        telephone: this.user.telephone,
        certification: this.user.certification,
        expiry: this.certExpiry(this.user.expiry),
        photo: null,
        current: this.user.current,
        target_id : "",
        title: "",
        description: "",
        reff_dates: "",
        attachment: "",
        status: "",
        message: "",
      }),
      process : false,
      currentStep : 0,
      operations : [],
      doc : false,
    }
  },
  mounted(){
    console.log(this.user.photo);
    let action = this.user.action;
    action.forEach((item) => {
      this.operations.push(item.action)      
    });
    this.progress = this.operations
  },   
  methods: {
    update() {
      this.form.post(`/users/${this.user.id}`, {
        preserveState: false,
        preserveScroll: true,
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.post(`/users/delete/${this.user.id}`)
      }
    },
    remove(attachment){
      if (confirm('Are you sure you want to delete this submitted certificate?')) {
        this.$inertia.post(`/profile/delete/attachments/${attachment.id}`, {
            preserveState: false,
            preserveScroll: true,
            onSuccess: () => {
              //
            }
        })
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.post(`/users/${this.user.id}/restore`)
      }
    },
    certExpiry(timestamp){
        return moment(timestamp).format("DD-MM-Y")
    },
    formUploader(){
      this.process = false;
      this.form.errors.title = ""
      this.form.errors.description = ""
      this.form.title = ""
      this.form.description = ""

      this.toggleModal()
    },
    is_valid(expiry){
      if(expiry === null) return true
      return false
    },
    processSubmission(attachment){

      this.form.errors.title = ""
      this.form.errors.description = ""

      this.process = true;
      this.form.target_id = attachment.id;
      this.form.title = attachment.title;
      this.form.description = attachment.description;
      this.form.reff_dates = moment(attachment.reff_dates).format("yyyy-MM-DD");
      this.form.status = attachment.status.process
      
      this.doc = attachment.attachment;

      //Update Labels : this.process
      let listProc = this.progress;
      let merged = [];
      listProc.forEach((proc) => {
          if(proc == "submitted") {
            merged.push(proc + " (" + moment(attachment.created_at).format("DD-MM-Y") + ", " + moment(attachment.created_at).fromNow() + ")"); 
          }else{
            merged.push(proc); 
          }
        });
      this.progress = merged;  

      this.currentStep = 0;
      attachment.workflows.forEach((item) => {
        let action = this.user.action;
        action.forEach((op) => {
          if(item.process == op.action) {
            this.currentStep = parseInt(op.weight);
          }
        });
      });
      this.toggleModal();
    },
    updateSubmission(){

      this.form.processing = true
      var rawDate = moment(this.form.expiry, "DD-MM-YYYY");
      
      const data = {
        target_id: this.form.target_id,
        status: this.form.status,
        message: this.form.message,
        certification: this.form.certification,
        expiry: moment(rawDate).format("yyyy-MM-DD"),
      };
      
      axios.post(`/profile/${this.user.id}/workflows`, data)
        .then(response => {
          this.$emit('update:attachments', response.data.attachments);
          this.form.processing = false
          if(response.data.status == 'success'){
            this.toggleModal()
            this.$page.props.flash.success = response.data.message
          }
        })
        .catch(error => { });
      
    },         
    uploadFile(e){

      if(this.form.title == ""){
        this.form.errors.title = "please enter certificate number/ID"
      }

      if(this.form.description == ""){
        this.form.errors.description = "please enter certificate title"
      }

      if(this.form.attachment == ""){
        alert('Please attach certificate in PDF format.')
        return
      }

      
      if(!this.form.reff_dates){
        alert('Please set the certificate date.')
        return
      }
            
      let reff_dates = (moment(this.form.reff_dates).isValid())? moment(this.form.reff_dates).format("yyyy-MM-DD") : null;
      this.form.reff_dates = reff_dates ;

      this.form.post(`/profile/${this.user.id}/attachments`, {
            preserveState: false,
            preserveScroll: true,
            onSuccess: () => {
              this.form.target_id = "";
              this.form.message = "";
              this.form.title = "";
              this.form.description = "";
              this.form.reff_dates = "";
              this.form.attachment = "";
            }
        })
      },
      changeStatus(){
        if(this.form.status == 'approved'){
          var dt_current = moment();
          let new_expiry = dt_current.add(1, 'years').format('DD-MM-Y');
          this.form.expiry = new_expiry
        }
      },
      generateFrom(target){
        this.form.post(`/reports/${this.user.id}/generate/${target}/`, {
            preserveState: false,
            preserveScroll: true,
            onSuccess: () => {
              
            }
        }) 
      },
      runme(){

      },    
  },
}
</script>
